module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-ring-4-7898d019aff5e8215f430c570d891e72.svg";